export default "__VITE_ASSET__cb71750a__"